import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IInviteQueuedModalProps {
    show: boolean;
    onClose: () => void;
}

export const InviteQueuedModal = (props: IInviteQueuedModalProps) => {
    const { t } = useTranslation();
    const { show, onClose } = props;

    return (
        <Modal centered backdrop="static" show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("it.invite.queuedModal.title")}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {t("it.invite.queuedModal.message")}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>
                    {t("general.close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};